export enum DemographicSections {
    childInformation = 1,
    childRaceEthnicity = 2,
    childLanguageInfo = 3,
    childProgramInfo = 4,
    specialEdInfo = 5
}